import { AddVTab } from './AddVTab';
import { DraggableVTab, VTab } from './DraggableVTab';
import styles from './DraggableVTabs.module.scss';

const DraggableVTabs = (props) => {
	const {
		handleReorder,
		items,
		order,
		activeTab,
		handleActiveTab,
		handleAddTab,
		limit,
		isDraggable,
		isDisabled,
		text,
	} = props;
	return (
		<div className={`${styles.root}`}>
			{order.map((id, idx) => {
				const { name } = items[id];
				if (isDraggable && !isDisabled) {
					return (
						<DraggableVTab
							key={id}
							id={id}
							text={name}
							moveCard={handleReorder}
							index={idx}
							active={id === activeTab}
							handleClick={handleActiveTab}
							isDraggable={isDraggable}
						/>
					);
				}
				return (
					<VTab
						isDraggable={isDraggable}
						key={id}
						id={id}
						text={name}
						index={idx}
						active={id === activeTab}
						handleClick={handleActiveTab}
					/>
				);
			})}
			{order.length < limit && !isDisabled && (
				<AddVTab text={text} handleClick={handleAddTab} />
			)}
		</div>
	);
};

DraggableVTabs.defaultProps = {
	limit: 10,
	isDraggable: true,
	isDisabled: false,
};

export default DraggableVTabs;
